export default ((process.env.NODE_ENV == 'dev') ? 'wss://ws.dev.api.doctorplan.com' : 'wss://ws.api.doctorplan.com')
